import { isEmpty, filter as lfilter, anyPass } from 'lodash/fp';
import { complement, pathOr } from 'rambda';
import {
  getCurrentRequestRole,
  IRequestState,
  requestDocumentName,
  requestStatus,
  roleRequireDocument,
  saveRequestStatus,
} from '.';
import { IDeaEditMode, IFeature } from '../common';

export const disableSaves =
  (feature: IFeature) => (requestState: IRequestState) => {
    const role = getCurrentRequestRole(requestState);

    const missingRole = () => role === '';
    const missingDeaNos = () => requestState.request.deaInfos.length === 0;

    const missingDocument = () =>
      !feature.disableDocUpload &&
      roleRequireDocument(role) &&
      requestState.file === void 0 &&
      requestDocumentName(requestState) === void 0;

    const missingJustification = () =>
      isEmpty(requestState.request.comments) &&
      requestState.request.reqType === 'REVOKE';

    const updating = () =>
      lfilter<IDeaEditMode>({ editMode: 'Read' })(requestState.request.deaInfos)
        .length !== requestState.request.deaInfos.length;

    const savingOrSubmitting = () => saveRequestStatus(requestState) === null;

    const submitted = () => requestStatus(requestState) === 'SUBMITTED';

    const validatedChange = () =>
      pathOr(false, 'changeValidated')(requestState);

    const disableSave = anyPass([
      missingRole,
      missingJustification,
      missingDeaNos,
      updating,
      missingDocument,
      savingOrSubmitting,
      submitted,
      validatedChange,
    ]);

    const disableCancel = anyPass([
      savingOrSubmitting,
      submitted,
      () => requestState.request.requestId === void 0,
    ]);

    const disableSubmit = anyPass([
      missingRole,
      missingJustification,
      missingDeaNos,
      updating,
      missingDocument,
      savingOrSubmitting,
      submitted,
      complement(validatedChange),
    ]);

    const disableRevokeSave = anyPass([
      () =>
        lfilter({ selected: true })(requestState.request.deaInfos).length === 0,

      missingJustification,

      validatedChange,
    ]);

    const disableRevokeSubmit = anyPass([
      () =>
        lfilter({ selected: true })(requestState.request.deaInfos).length === 0,

      missingJustification,

      () => requestState.request.requestId === void 0,

      complement(validatedChange),
    ]);

    const disableRenewSave = anyPass([
      () =>
        lfilter({ selected: true })(requestState.request.deaInfos).length === 0,

      validatedChange,
    ]);

    const disableRenewSubmit = anyPass([
      () =>
        lfilter({ selected: true })(requestState.request.deaInfos).length === 0,

      () => requestState.request.requestId === void 0,

      complement(validatedChange),
    ]);

    return {
      disableSave,
      disableCancel,
      disableSubmit,

      disableRevokeSave,
      disableRevokeSubmit,

      disableRenewSave,
      disableRenewSubmit,
    };
  };
